module.exports = "/fast-coin/img/coin/anim/in/coin_in_013.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_013.png
// module id = 2283
// module chunks = 5